<div class="container" xmlns="http://www.w3.org/1999/html">
  <div class="title">
    {{ optionTitle }}
  </div>
  <div class="lead">
    {{ optionLead }}
  </div>
  <div class="table">
    <div class="table--row head" *ngIf="optionHeading">
      <div class="order" *ngIf="ordering">
        {{ cbOrder }}
      </div>
      <div class="head" [class.orderHidden]="!ordering">
        {{ cbOption }}
      </div>
      <div class="head" [class.orderHidden]="!ordering">
        {{ cbCheckbox }}
      </div>
    </div>
    <div class="table--row" *ngFor="let o of options; let i = index">
      <div class="order" *ngIf="ordering">
        {{ i + 1 }}
      </div>
      <div [class.orderHidden]="!ordering" *ngIf="o.id.length > 2">
        {{ o.text }}
      </div>
      <div [class.orderHidden]="!ordering" *ngIf="o.id.length < 3">
        <input [(ngModel)]="o.text" (ngModelChange)="changeSelectedInputToo($event, o.id)" />
      </div>
      <div [class.orderHidden]="!ordering">
        <div class="checkbox" tabindex="0" (keydown.space)="selectCheckbox($event, o)" (click)="selectCheckbox($event, o)">
          <img *ngIf="isSelected(o.id)" src="assets/images/icons/check-green.svg" />
        </div>
      </div>
    </div>

    <div class="buttons" *ngIf="customOptionEnabled">
      <button class="button" (click)="addNewOption()" [class.disabled]="formControl.disabled">Sor hozzáadása</button>
      <button class="button" (click)="removeLastOption()" [class.disabled]="this.options.length <= this.initialOptionLength || formControl.disabled">
        Sor törlése
      </button>
    </div>

    <div class="title">
      {{ selectorTitle }}
    </div>
    <div class="lead">
      {{ selectorLead }}
    </div>

    <div class="table--row head" *ngIf="selectorHeading">
      <div class="order" *ngIf="ordering">
        {{ selOrder }}
      </div>
      <div class="head" [class.orderHidden]="!ordering">
        {{ selOption }}
      </div>
      <div class="head" [class.orderHidden]="!ordering">
        {{ selText }}
      </div>
    </div>
    <div class="table--row" *ngFor="let o of selectedValues; let i = index">
      <div class="order" *ngIf="ordering">
        {{ i + 1 }}
      </div>
      <div [class.orderHidden]="!ordering">
        {{ o.text }}
      </div>
      <div [class.orderHidden]="!ordering">
        <input
          appAllownumbersonly
          [(ngModel)]="o.numberOf"
          (ngModelDebounceChange)="setSelectedValues()"
          [disabled]="formControl.disabled"
        />
      </div>
    </div>
    <app-error-message *ngIf="formControl.errors && formControl.touched" [validationErrors]="formControl.errors"></app-error-message>
    <div *ngIf="screen2Title">
      <div class="buttons">
        <button
          class="button"
          [class.disabled]="
            selectedValues.length < (requiredSelectedAmount ?? 1) ||
            selectedValues.length > (maximumSelectedAmount ?? 3) ||
            formControl.disabled
          "
          [disabled]="
            selectedValues.length < (requiredSelectedAmount ?? 1) ||
            selectedValues.length > (maximumSelectedAmount ?? 3) ||
            formControl.disabled
          "
          (click)="creteFormArrayFromSelectedValues()"
        >
          Küldőpiacok mentése
        </button>
      </div>
      <div *ngIf="firstFormCreated">
        <div class="title">
          {{ screen2Title }}
        </div>
        <div class="lead">
          {{ screen2Lead }}
        </div>
        <div class="flex">
          <div *ngFor="let v of selectedValues; let i = index" (click)="setFormGroupSelected(i)" style="cursor: pointer">
            <div
              [class.green]="hasValue(firstCheckBoxGroup, i)"
              [class.selected-value]="selectedActivityIndex === i"
              (click)="formControl.disabled ? null : (selectedActivityIndex = i)"
            >
              {{ v.text }}
            </div>
          </div>
        </div>
        <form [formGroup]="firstCheckBoxGroup">
          <form [formGroup]="getFormGroup(firstCheckBoxGroup, 'fg' + selectedFormGroupValue)" class="activities-list">
            <div class="row">
              <div class="order">{{ screen2SerialHeader }}</div>
              <div class="types">{{ screen2OptionHeader }}</div>
              <div class="selected">{{ screen2checkboxHeader }}</div>
            </div>
            <div class="row" *ngFor="let a of activities; let i = index">
              <div class="order">{{ i + 1 }}</div>
              <div class="types">{{ a.text }}</div>
              <div class="selected">
                <label class="custom-checkbox" [class.disabled-checkbox]="formControl.disabled">
                  <input type="checkbox" class="checkbox-input" [formControlName]="'fc' + i" tabindex="0"/>
                  <span class="checkmark"></span>
                  <span class="icon">✓</span>
                </label>
              </div>
            </div>
          </form>
        </form>
        <div class="title">
          {{ screen3Title }}
        </div>
        <div class="lead">
          {{ screen3Lead }}
        </div>
        <div class="flex">
          <div *ngFor="let v of selectedValues; let i = index" (click)="regionsFormGroupSelected = i" style="cursor: pointer">
            <div
              [class.green]="hasValue(regionsFormGroup, i)"
              [class.selected-value]="selectedRegionIndex === i"
              (click)="formControl.disabled ? null : (selectedRegionIndex = i)"
            >
              {{ v.text }}
            </div>
          </div>
        </div>
        <form [formGroup]="regionsFormGroup">
          <form [formGroup]="getFormGroup(regionsFormGroup, 'fg' + regionsFormGroupSelected)" class="activities-list">
            <div class="row">
              <div class="order">{{ screen3SerialHeader }}</div>
              <div class="types">{{ screen3OptionHeader }}</div>
              <div class="selected">{{ screen3checkboxHeader }}</div>
            </div>
            <div class="row" *ngFor="let a of regions; let i = index">
              <div class="order">{{ i + 1 }}</div>
              <div class="types">{{ a.text }}</div>
              <div class="selected">
                <label class="custom-checkbox" [class.disabled-checkbox]="formControl.disabled">
                  <input type="checkbox" class="checkbox-input" [formControlName]="'fc' + i" tabindex="0"/>
                  <span class="checkmark" role="checkbox" aria-checked="false"></span>
                  <span class="icon">✓</span>
                </label>
              </div>
            </div>
          </form>
        </form>
        <div class="buttons">
          <button
            class="button"
            [disabled]="regionsFormGroup.invalid || firstCheckBoxGroup.invalid || formControl.disabled"
            [class.disabled]="regionsFormGroup.invalid || firstCheckBoxGroup.invalid || formControl.disabled"
            (click)="getValuesandSetForm()"
          >
            Preferenciák mentése
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
